module.exports = __webpack_public_path__ + "static/img/template_screenshot-min.07710f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/min/template_screenshot-min.jpg
// module id = orBY
// module chunks = 1